import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

const base = "/api/admin/websitev2/legal";

export const getLegalListSaga = createAction(
  "GET_LEGAL",
  ({ payload, params }: SagaActionParams<Type.LegalDocDto[]>) => ({
    payload,
    url: base + (params ? params : ""),
  })
);
export const createLegalSaga = createAction(
  "CREATE_LEGAL",
  ({ payload, body }: SagaActionParams<Type.LegalDocDto>) => ({
    payload,
    url: base,
    body,
  })
);
export const updateLegalSaga = createAction(
  "UPDATE_LEGAL",
  ({ payload, id, body }: SagaActionParams<Type.LegalDocDto>) => ({
    payload,
    url: base + "/" + id,
    body,
  })
);
export const deleteLegalSaga = createAction(
  "DELETE_LEGAL",
  ({ payload, id }: SagaActionParams<Type.LegalDocDto>) => ({
    payload,
    url: base + "/" + id,
  })
);

const legalSaga = [
  takeLatest<any>(
    getLegalListSaga.toString(),
    (payload: SagaGenericParams<Type.LegalDocDto[]>) =>
      getSaga<Type.LegalDocDto[]>(payload)
  ),
  takeLatest<any>(
    createLegalSaga.toString(),
    (payload: SagaGenericParams<Type.LegalDocDto>) =>
      postSaga<Type.LegalDocDto>(payload)
  ),
  takeLatest<any>(
    updateLegalSaga.toString(),
    (payload: SagaGenericParams<Type.LegalDocDto>) =>
      putSaga<Type.LegalDocDto>(payload)
  ),
  takeLatest<any>(
    deleteLegalSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.LegalDocDto>(payload)
  ),
];

export default legalSaga;
